import styled from '@emotion/styled';

export const StyledExclamationMark = styled.span`
  &:before {
    color: red;
    content: '!';
    font-size: 24px;
    font-weight: 600;
  }
`;
